// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/marching-forward.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const marchingForward: Score = {
  slug: "marching-forward",
  n: 17,
  title: "Marching Forward",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "F",
  fifths: -1,
  time: [4, 4],
  tempo: 108,
  staves: 2,
  clefs: ["treble", "bass"],
  bars: 8,
  barQuarters: 4.0,
  lowest: 41,
  highest: 81,
  hasLyrics: false,
  jasonNote: "This left hand pattern is popularly used across a wide range of music - Rock n Roll, Ragtime, Country, Classical music and more. I've composed this piece on F Major",
  teaches: ["the stride / oom-pah left hand", "the pattern behind rock'n'roll, ragtime and country"],
  art: "/sight-reading/art/marching-forward.jpg",
  artRights: "stock",
  background: "/sight-reading/bg/marching-forward.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 1, hand: "lh", start: 0.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 1, hand: "lh", start: 1.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 1, hand: "lh", start: 1.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 1, hand: "lh", start: 2.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter" },
    { bar: 1, hand: "lh", start: 3.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 1, hand: "lh", start: 3.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 2, hand: "rh", start: 4.0, dur: 1.5, midi: 81, pitch: "A5", d: "quarter", dot: true },
    { bar: 2, hand: "lh", start: 4.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 2, hand: "lh", start: 5.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 2, hand: "lh", start: 5.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 2, hand: "rh", start: 5.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth" },
    { bar: 2, hand: "rh", start: 6.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter" },
    { bar: 2, hand: "lh", start: 6.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 2, hand: "rh", start: 7.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 2, hand: "lh", start: 7.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 2, hand: "lh", start: 7.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 3, hand: "lh", start: 8.0, dur: 1.0, midi: 58, pitch: "Bb3", d: "quarter" },
    { bar: 3, hand: "lh", start: 8.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 3, hand: "rh", start: 9.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter" },
    { bar: 3, hand: "lh", start: 9.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 3, hand: "lh", start: 10.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 3, hand: "lh", start: 10.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter" },
    { bar: 3, hand: "lh", start: 11.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 4, hand: "rh", start: 12.0, dur: 1.0, midi: 70, pitch: "Bb4", d: "quarter" },
    { bar: 4, hand: "lh", start: 12.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 4, hand: "lh", start: 12.0, dur: 1.0, midi: 58, pitch: "Bb3", d: "quarter", chord: true },
    { bar: 4, hand: "rh", start: 13.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 4, hand: "lh", start: 13.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 4, hand: "lh", start: 13.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 4, hand: "rh", start: 14.0, dur: 2.0, midi: 67, pitch: "G4", d: "half" },
    { bar: 4, hand: "lh", start: 14.0, dur: 0.5, midi: 60, pitch: "C4", d: "eighth" },
    { bar: 4, hand: "lh", start: 14.5, dur: 0.5, midi: 58, pitch: "Bb3", d: "eighth" },
    { bar: 4, hand: "lh", start: 15.0, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 4, hand: "lh", start: 15.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 5, hand: "lh", start: 16.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 5, hand: "rh", start: 17.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 5, hand: "lh", start: 17.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 5, hand: "lh", start: 17.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 5, hand: "rh", start: 18.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 5, hand: "lh", start: 18.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter" },
    { bar: 5, hand: "lh", start: 19.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 5, hand: "lh", start: 19.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 6, hand: "rh", start: 20.0, dur: 1.5, midi: 81, pitch: "A5", d: "quarter", dot: true },
    { bar: 6, hand: "lh", start: 20.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 6, hand: "lh", start: 21.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 6, hand: "lh", start: 21.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 6, hand: "rh", start: 21.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth" },
    { bar: 6, hand: "rh", start: 22.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter" },
    { bar: 6, hand: "lh", start: 22.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 6, hand: "rh", start: 23.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 6, hand: "lh", start: 23.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 6, hand: "lh", start: 23.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 7, hand: "rh", start: 24.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 7, hand: "lh", start: 24.0, dur: 1.0, midi: 58, pitch: "Bb3", d: "quarter" },
    { bar: 7, hand: "lh", start: 24.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 7, hand: "rh", start: 25.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter" },
    { bar: 7, hand: "lh", start: 25.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 7, hand: "lh", start: 26.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 7, hand: "lh", start: 26.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", chord: true },
    { bar: 7, hand: "rh", start: 27.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter" },
    { bar: 7, hand: "lh", start: 27.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 77, pitch: "F5", d: "whole" },
    { bar: 8, hand: "lh", start: 28.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 8, hand: "lh", start: 29.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 8, hand: "lh", start: 30.0, dur: 2.0, midi: 41, pitch: "F2", d: "half" },
  ],
};
